/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Last_SuccessInputs */



/**
* | output |
* | --- |
* | "Last success" |
*
* @param {Admin_Status_Last_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_last_success = /** @type {((inputs?: Admin_Status_Last_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Last_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernier succès")
	if (locale === "es") return /** @type {LocalizedString} */ ("Último éxito")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Último sucesso")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimo successo")
	return /** @type {LocalizedString} */ ("Last success")
});